import React from 'react';
import { ThemeProvider } from './core/contexts/ThemeContext';
import { WindowProvider } from './core/contexts/WindowContext';
import { AppRegistryProvider } from './core/contexts/AppRegistry';
import { Desktop } from './components/OS/Desktop';
export function App() {
  return <ThemeProvider data-id="element-0" data-mp="3fahyiundazbl">
      <WindowProvider data-id="element-1" data-mp="3f9yjblp3qp19">
        <AppRegistryProvider data-id="element-2" data-mp="3fbt3uywgof4t">
          <Desktop data-id="element-3" data-mp="3f8exzgol9nsm" />
        </AppRegistryProvider>
      </WindowProvider>
    </ThemeProvider>;
}